export const SET_QA = 'SET_QA'
export const SET_QA_ANSWERS = 'SET_QA_ANSWERS'
export const SET_QA_CONDITIONS = 'SET_QA_CONDITIONS'